import { FileText, ChevronRight } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface RatifiedCharterCardProps {
  onClick: () => void
  charterVersion: number
}

export function RatifiedCharterCard({
  onClick,
  charterVersion,
}: RatifiedCharterCardProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full text-left bg-white border border-slate-100 rounded-lg p-3 shadow-sm',
        'hover:border-slate-200 hover:shadow-md transition-all group'
      )}
    >
      <div className='flex items-center justify-between mb-2'>
        <div className='flex items-center gap-1.5'>
          <FileText className='h-3.5 w-3.5 text-emerald-500 flex-shrink-0' />
          <span className='text-xs font-semibold text-slate-700'>
            Team Charter
          </span>
        </div>
        <div className='flex items-center gap-1.5'>
          <Badge
            variant='outline'
            className='text-[10px] px-1.5 py-0 h-4 font-medium bg-emerald-50 text-emerald-700 border-emerald-200'
          >
            Ratified
          </Badge>
          <ChevronRight className='h-3 w-3 text-slate-400 group-hover:text-slate-600 transition-colors' />
        </div>
      </div>

      <div className='flex items-center gap-2'>
        <span className='text-[10px] text-slate-400'>
          Version {charterVersion}
        </span>
        <span className='text-[10px] text-slate-300'>·</span>
        <Badge
          variant='outline'
          className='text-[10px] px-1.5 py-0 h-4 font-medium bg-gray-50 text-gray-600 border-gray-200'
        >
          Locked
        </Badge>
      </div>
    </button>
  )
}
